var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCursosLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 7.49992H3C2.88949 7.49992 2.78351 7.54382 2.70537 7.62196C2.62723 7.7001 2.58333 7.80608 2.58333 7.91659C2.58333 8.02709 2.62723 8.13307 2.70537 8.21121C2.78351 8.28935 2.88949 8.33325 3 8.33325H9.25V9.16659H3C2.66848 9.16659 2.35054 9.03489 2.11612 8.80047C1.8817 8.56605 1.75 8.24811 1.75 7.91659V1.66659C1.75 1.44557 1.8378 1.23361 1.99408 1.07733C2.15036 0.921049 2.36232 0.833252 2.58333 0.833252H9.25V7.49992ZM2.58333 6.68742C2.65083 6.67367 2.72042 6.66659 2.79167 6.66659H8.41667V1.66659H2.58333V6.68742ZM7.16667 3.74992H3.83333V2.91659H7.16667V3.74992Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCursosLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cursos-line.846fda7e.svg";
export { ForwardRef as ReactComponent };